/**
 * @file Show the fingerprint and connection details while waiting for the
 * mobile side to tap "許可する". Mirrors export_architecture_v2 §5.5.
 */

import { FingerprintCard } from "./FingerprintCard";
import type { ExportSessionDoc } from "../types";

export function AwaitingApproval({ session }: { session: ExportSessionDoc & { id: string } }) {
  const expiresAt = session.expires_at?.toDate?.() ?? null;
  return (
    <section style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <h1 style={{ marginTop: 0 }}>モバイルでの承認をお待ちしています</h1>
      <p style={{ color: "var(--color-text-sub)", lineHeight: 1.7 }}>
        モバイルアプリの承認画面に表示されている確認コードと、
        以下のコードが一致することを目視で確認してから「許可する」をタップしてください。
      </p>
      <div>
        <p style={{ fontSize: "13px", color: "var(--color-text-sub)", margin: "0 0 12px" }}>
          確認コード:
        </p>
        <FingerprintCard seedB64={session.fingerprint_seed} />
      </div>
      <div
        style={{
          padding: "12px 16px",
          borderRadius: "12px",
          background: "var(--color-surface)",
          border: "1px solid var(--color-border)",
          fontSize: "13px",
          color: "var(--color-text-sub)",
          lineHeight: 1.7,
        }}
      >
        <div>
          接続元: あなたの PC{" "}
          {typeof navigator !== "undefined" ? `(${navigator.userAgent.slice(0, 60)}…)` : ""}
        </div>
        {expiresAt && <div>有効期限まで: {formatRemaining(expiresAt)}</div>}
      </div>
    </section>
  );
}

function formatRemaining(expiresAt: Date): string {
  const ms = expiresAt.getTime() - Date.now();
  if (ms <= 0) return "00:00";
  const totalSec = Math.floor(ms / 1000);
  const mm = String(Math.floor(totalSec / 60)).padStart(2, "0");
  const ss = String(totalSec % 60).padStart(2, "0");
  return `${mm}:${ss}`;
}
